(function ($) {
  'use strict';

  /**
   * Custom Selects
   * ---
   * (Select2.js)[https://select2.org/]
   */

  $(document).ready(function () {
    $('.js-custom-select').select2({
      width: 'style',
      minimumResultsForSearch: -1,
    });
  });


  /**
   * Stories Ajax Pagination
   * ===
   * `stories_loadmore_params` - Object passed from WP enqueue script function
   */

  /**
   * Load More - Pagination + Filters
   */

  var $stories_load_button      = $( '#js-stories-load' );
  var $stories_filters          = $('.stories-ajax-filters select')
  var $stories_filter_category  = $('#stories-filter-category');
  var $stories_filter_orderby   = $('#stories-filter-orderby');

  $stories_load_button.on('click', function (e) {
    // Get Default Filter Values
    var filter_category = $stories_filter_category.val();
    var filter_orderby  = $stories_filter_orderby.val();

    ajax_load_more( $(this), stories_loadmore_params, filter_category, filter_orderby );
    e.preventDefault();
  });

  // Category Filter
  $stories_filter_category.on('change', function (e) {
    var $this = $(this);
    var filter_category = $stories_filter_category.val();
    var filter_orderby  = $stories_filter_orderby.val();

    // Reload results with new filter applied
    ajax_apply_filter( $this, stories_loadmore_params, $this.val(), filter_orderby );

    e.preventDefault();
  });

  // Orderby Filter
  $stories_filter_orderby.on('change', function (e) {
    var $this = $(this);
    var filter_category = $stories_filter_category.val();
    var filter_orderby  = $stories_filter_orderby.val();

    // Reload results with new filter applied
    ajax_apply_filter( $this, stories_loadmore_params, filter_category, $this.val() );

    e.preventDefault();
  });


  /**
   * Ajax Load More
   */

  function ajax_load_more( $button, stories_loadmore_params, filter_category = '', filter_orderby = '' ) {
    var nonce = $button.data('nonce');
    var data  = {
      'action'    : 'loadmore',
      'query'     : stories_loadmore_params.posts,
      'page'      : stories_loadmore_params.current_page,
      'nonce'     : nonce,
      'category'  : filter_category,
      'orderby'   : filter_orderby,
      'refresh'   : false,
    };

    $.ajax({
      url: stories_loadmore_params.ajaxurl,
      data: data,
      type: 'POST',
      beforeSend: function ( xhr ) {
        var $button_loading_label = $button.data( 'loading-label' );
        // Disable Load More Button
        $button.prop( 'disabled', true )
          .find('.button-title')
          .text( $button_loading_label );
        // Disable Filters
        $stories_filters.prop( 'disabled', true );
      },
      success: function ( data ) {
        if ( data ) {
          $('#stories-ajax-load-container').append( data );
          var $button_label = $button.data( 'button-label' );
          var max_pages = $('[data-max-pages]:last').data('max-pages');

          if ( ! max_pages ) {
            max_pages = stories_loadmore_params.max_page;
          }

          // console.log( 'Max Pages: ' + max_pages );
          // console.log( $('[data-max-pages]:last') );

          // Enable Load More Button
          $button.prop( 'disabled', false )
            .find('.button-title')
            .text( $button_label );

          // Enable Filters
          $stories_filters.prop( 'disabled', false );

          stories_loadmore_params.current_page++;

          // if last page, disable the button
          if ( stories_loadmore_params.current_page == max_pages ) {
            $button.prop( 'disabled', true );
          }
        } else {
          // if no data, disable the button
          $button.prop( 'disabled', true );
        }
      }
    });
  }

  function ajax_apply_filter( $input, stories_loadmore_params, filter_category = '', filter_orderby = '' ) {
    var $button = $( '#js-stories-load' );
    var nonce = $input.data('nonce');
    var data  = {
      'action'    : 'loadmore',
      'query'     : stories_loadmore_params.posts,
      'page'      : 1,
      'nonce'     : nonce,
      'category'  : filter_category,
      'orderby'   : filter_orderby,
      'refresh'   : true,
    };
    $.ajax({
      url: stories_loadmore_params.ajaxurl,
      data: data,
      type: 'POST',
      beforeSend: function ( xhr ) {
        var $button_loading_label = $button.data( 'loading-label' );
        $button.prop( 'disabled', true )
          .find('.button-title')
          .text( $button_loading_label );
        $stories_filters.prop( 'disabled', true );
      },
      success: function ( data ) {
        if ( data ) {
          $('#stories-ajax-load-container').html( data );
          var $button_label = $button.data( 'button-label' );
          var max_pages = $('[data-max-pages]:last').data('max-pages');

          if ( ! max_pages ) {
            max_pages = stories_loadmore_params.max_page;
          }

          // console.log( 'Max Pages: ' + max_pages );
          // console.log( $('[data-max-pages]:last') );

          $button.prop( 'disabled', false )
            .find('.button-title')
            .text( $button_label );

          $stories_filters.prop( 'disabled', false );

          stories_loadmore_params.current_page = 1;

          // if last page, disable the button
          if ( stories_loadmore_params.current_page == max_pages ) {
            $button.prop( 'disabled', true );
          }
        } else {
          // if no data, disable the button
          $button.prop( 'disabled', true );
        }
      }
    });
  }

})(jQuery);
